import React, { Fragment } from "react";
import { useTranslation } from "react-i18next";

//Custom Components
import MapCard from "@/ui/MapCard/MapCard";
import MapCardHeader from "@/ui/MapCard/MapCardHeader";
import MapCardAvatar from "@/ui/MapCard/MapCardAvatar";
import MapCardContent from "@/ui/MapCard/MapCardContent";
import MapCardHeaderButtonClose from "@/ui/MapCard/MapCardHeaderButtonClose";


//@ts-ignore
import Image360 from "Views/Operations/Image360";

export type CardPosition = [number, number]

export type CardOverlayType = "gsinfo" | "dkp" | "kb" | "nc" | "photos360"

export interface Image360InfoCardProps {
  id: number,
  fileName: string,
  title?: string,
  onClose: any

}

function Image360InfoCard(props: Image360InfoCardProps) {
  const { t } = useTranslation();

  const { id, fileName, title, onClose } = props;

  const faIconClass = "fas fa-eye ";
  const titleLabel = title ? title : fileName;

  return (
    <Fragment>
      <MapCard
        sx={{
          backgroundColor: "background.default",
          minWidth: "250px"
        }}
      >
        <MapCardHeader
          title={titleLabel}
          subheader={t("common.id") + ": " + id}
          subheaderTypographyProps={{ color: "initial" }}
          avatar={<MapCardAvatar ariaLabel="info" icon={<i className={faIconClass}></i>} />}
          action={<MapCardHeaderButtonClose onClick={onClose} />}
        />
        <MapCardContent>
          <Image360 key={id} fileName={fileName} id={id.toString()} />
        </MapCardContent>
      </MapCard>
    </Fragment>
  );
}

export default Image360InfoCard;
